import * as marietta from '../..';
import * as graphicLibs from '../../graphicLibs/index';
import * as THREE from 'three';
import { BUILDING_TYPE_MANSION, ITEM_MODE_NO } from '../Constants';
import { beamType } from '../../LiDAR/commands/change2DfromLiDAR/AddRoom2D';

export class AutoBeam {

    private height: number; // mm 高さ デフォルト値(500mm)(https://mari.backlog.jp/view/STARTS_LIDAR-1225#comment-1416753716)

    private widthMansionDefault_MM: number; // mm マンション デフォルト値(350mm) (https://mari.backlog.jp/view/STARTS_LIDAR-1225#comment-1416753716)

    private widthMansionDefault_Pix: number; // px

    private widthHouseDefault_Pix: number; // px 戸建て デフォルト値(モジュールピッチ / 4)

    constructor() {
        // 梁デフォルト高さ
        this.height = 500; // mm
        // マンションの梁デフォルト幅
        this.widthMansionDefault_MM = 350; // mm
        this.widthMansionDefault_Pix = marietta.webcad.util.WebCADUtil.convertMMToPix(this.widthMansionDefault_MM); // pix (https://mari.backlog.jp/view/STARTS_LIDAR-1225#comment-1416753716)
        // 戸建ての梁デフォルト幅
        this.widthHouseDefault_Pix = marietta.webcad.WebCADGlobal.PIX_IN_GRID / 4; // pix
    }

    /**
     * 外周に梁を生成
     * ※ただし、囲まれている壁が90度の場合のみ
     */
    public createBeamOuterWall() {
        const createBeam = [];
        const outerPointsList = this.getOuterPoints(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);

        for (let i = 0; i < outerPointsList.length; i++) {
            const outerPoints = outerPointsList[i];
            for (let j = 0; j < outerPoints.length; j++) {
                const p1 = outerPoints[j];
                const p2 = outerPoints[(j + 1) % outerPoints.length];
                const p3 = outerPoints[(j + 2) % outerPoints.length];
                const p4 = outerPoints[(j + 3) % outerPoints.length];

                // 壁に頂点が乗っていない方に向かってベクトルを作成する
                const vec1 = p1.clone().sub(p2).normalize();
                const vec2 = p4.clone().sub(p3).normalize();
                // 基準壁
                const line = p3.clone().sub(p2).normalize();

                const sin1 = line.clone().cross(vec1);
                const sin2 = line.clone().cross(vec2);

                // 符号が同じ && 直角
                const rightAngle = ((0.9986 <= sin1 && sin1 <= 1) && (0.9986 <= sin2 && sin2 <= 1));
                if (!rightAngle) continue;

                // 梁を生成
                const shape = [];
                if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
                    const pixP1 = vec1.clone().multiplyScalar(this.widthMansionDefault_Pix).add(p2);
                    const pixP4 = vec2.clone().multiplyScalar(this.widthMansionDefault_Pix).add(p3);
                    const convertPixToMM = marietta.webcad.util.WebCADUtil.convertPixToMM;
                    shape.push(...[
                        new THREE.Vector2(convertPixToMM(pixP1.x), convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H - pixP1.y)),
                        new THREE.Vector2(convertPixToMM(p2.x), convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H - p2.y)),
                        new THREE.Vector2(convertPixToMM(p3.x), convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H - p3.y)),
                        new THREE.Vector2(convertPixToMM(pixP4.x), convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H - pixP4.y))
                    ]);
                } else {
                    const pixP1 = vec1.clone().multiplyScalar(this.widthHouseDefault_Pix).add(p2);
                    const pixP4 = vec2.clone().multiplyScalar(this.widthHouseDefault_Pix).add(p3);
                    shape.push(...[
                        new THREE.Vector2(pixP1.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - pixP1.y),
                        new THREE.Vector2(p2.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - p2.y),
                        new THREE.Vector2(p3.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - p3.y),
                        new THREE.Vector2(pixP4.x, marietta.webcad.WebCADGlobal.LAYER_SIZE_H - pixP4.y)
                    ]);
                }
                createBeam.push({
                    shape: shape,
                    height: this.height
                });
            }
        }

        this.createBeam(createBeam,  marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor);

        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
    }

    private createBeam(obj: beamType[], floor: number) {
        const infos = []
        if (obj.length == 0) return;
        for (let i = 0; i < obj.length; i++) {
            const beamData: any = {};
            beamData.index = 0;
            beamData.id = 'bem01_01';
            beamData.f = floor;
            beamData.height = obj[i].height;
            beamData.shape = obj[i].shape;

            infos.push(beamData);
        }

        marietta.webcad.util.WebcadJSONParser.reproduceBeamItem(infos);
    }

    /**
     * 外周の頂点リストを取得
     * @param floor
     * @returns
     */
    private getOuterPoints(floor: number): THREE.Vector2[][] {
        marietta.webcad.WebCADGlobal.scene = new graphicLibs.Scene();

        const roomList: marietta.webcad.item.Room[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
        const allPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);
        allPointList.forEach((pList: number[][]) => {
            marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.ClosePath(pList));
        });

        // 階の建具の情報を足す
        const wallList: marietta.webcad.item.WallObject[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(floor, ITEM_MODE_NO.MODE_WALL_NO)).getAllChildren();
        const wallPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllWallPointList(wallList);
        for (let i: number = 0; i < wallPointList.length; i += 1) {
            marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.Line(new THREE.Vector2(wallPointList[i][0].x, wallPointList[i][0].y), new THREE.Vector2(wallPointList[i][1].x, wallPointList[i][1].y)));
        }

        const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();

        const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;

        // 直線上に頂点があった場合は、頂点を削除する
        return outerList.map((outer: number[]) => {
            const fiterOuterIndexes = outer.filter((index: number, i: number, array: number[]) => {
                const p1 = points[array[(i + array.length - 1) % array.length]];
                const p2 = points[index];
                const p3 = points[array[(i + 1) % array.length]];
                return !this.isPointOnLineSegment(p1, p2, p3); // 直線上にない点のみ採用
            });
            return fiterOuterIndexes.map((index: number) => {
                return points[index];
            });
        });

    }

    /**
     * p2がp1とp3の直線上にあるか
     * @param p1
     * @param p2
     * @param p3
     * @returns
     */
    private isPointOnLineSegment(p1: THREE.Vector2, p2: THREE.Vector2, p3: THREE.Vector2): boolean {
        const e = 0.05; // 許容誤差

        const p1p2 = p2.clone().sub(p1);
        const p1p3 = p3.clone().sub(p1);

        const crossProduct = p1p2.cross(p1p3);

        // 外積の絶対値が非常に小さい場合、p2 は線分上に存在とみなす
        if (Math.abs(crossProduct) < e) {
            // p2 が線分上に存在すると判定
            return p2.x >= Math.min(p1.x, p3.x) && p2.x <= Math.max(p1.x, p3.x) &&
                   p2.y >= Math.min(p1.y, p3.y) && p2.y <= Math.max(p1.y, p3.y);
        }

        // 外積が非常に小さくない場合、p2 は線分上に存在しない
        return false;
    }

}